import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MENU_ITEMS, MenuItem } from '@shared/core';
import { Observable, isObservable, of } from 'rxjs';

@Component({
    selector: 'shared-default-menu',
    imports: [CommonModule, RouterModule],
    templateUrl: './default-menu.component.html',
})
export class DefaultMenuComponent {
    readonly menuItems$: Observable<MenuItem[]> = (() => {
        const items = inject(MENU_ITEMS);
        return isObservable(items) ? (items as Observable<MenuItem[]>) : of(items as MenuItem[]);
    })();

    trackByMenuItem(_: number, item: MenuItem): string {
        return item.link;
    }
}
